const isReactSnapping = () => navigator.userAgent === 'ReactSnap';

export default isReactSnapping;
